module.exports = __webpack_public_path__ + "static/media/favicon.d264d748.ico";